export enum EmailRecipientTypeEnum {
    To = 1,
    Cc = 2,
    Bcc = 3
}

export enum QuickStartPageEnum {
    IntroduceMessageCenter = 0,
    SendReceiveEmail = 1,
    ActionAvailable = 2
}

export interface QuickstartTabModel {
	title?: string;
	vm?: any;
	path?: string;
	model?: any;
	show: boolean | (() => boolean);
	id?: string;
}